"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteSchemaProperties = exports.NoteSchema = exports.NoteStatusEnum = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
exports.NoteStatusEnum = zod_1.z.enum(["shared", "deleted", "private"]);
exports.NoteSchema = base_schema_1.BaseSchema.extend({
    richContent: zod_1.z.string().optional(),
    content: zod_1.z.string().optional(),
    title: zod_1.z.string(),
    status: exports.NoteStatusEnum,
    appointmentIds: zod_1.z.array(zod_1.z.string()).optional(),
    lock: zod_1.z
        .object({
        memberId: zod_1.z.string(),
        expiresAt: zod_1.z.number(),
    })
        .nullable()
        .optional(),
    clientId: zod_1.z.string().optional(),
});
exports.NoteSchemaProperties = {
    collectionName: "notes",
    deleteMode: schema_properties_interface_1.DeleteMode.None,
};
//# sourceMappingURL=note-schema.js.map